import { Plugin } from 'vue'
import { frill } from '@frillco/script'

/*
  Frill, which shows feature announcements from the app header, loaded with the Frill Script
  (https://developers.frill.co/frill-script/quick-start). It replaces the legacy widget.js, which Frill stopped
  supporting in 2026.
*/

// Company-wide key from Frill's Settings → Frill Script page (https://app.frill.co/settings/company/frill-script)
export const FRILL_SCRIPT_KEY = '594b0810-25da-41ce-8906-b1195ea8e173'

// The announcements widget that the header's megaphone opens (see frill-widget.vue)
export const FRILL_WIDGET_KEY = '02340907-3e4a-4b59-8a2b-25088bf1489f'

/** Identifies the signed-in user to Frill by email, so their votes and comments aren't anonymous */
export function identifyFrillUser(user: { email: string; name: string }) {
  if (!FRILL_SCRIPT_KEY || !user.email) {
    return
  }
  frill('identify', user).catch(error => console.error('Frill failed to identify the user', error))
}

export default {
  install() {
    if (!FRILL_SCRIPT_KEY) {
      return
    }
    // Once per page load, as early as possible. Nothing loads on its own: the header loads the widget, which keeps it
    // off pages that customers see, such as the ticket portal
    frill('container', { key: FRILL_SCRIPT_KEY, autoLoad: false }).catch(error =>
      console.error('Frill failed to load', error),
    )
  },
} as Plugin
